"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var moment = require('moment');
var PAGE_LIMIT = 5;
var AVAILABLE_PRODUCTS_ERROR = 'Error getting information about available products';
var EVENT_ENTITLEMENTS_ERROR = 'Error getting information about workspace entitlements';
var OrgEventEntitlements = /*#__PURE__*/function () {
  OrgEventEntitlements.$inject = ["$rootScope", "$scope", "$filter", "eventService", "entitlementsService", "userService"];
  /* @ngInject */
  function OrgEventEntitlements($rootScope, $scope, $filter, eventService, entitlementsService, userService) {
    _classCallCheck(this, OrgEventEntitlements);
    this.$scope = $scope;
    this.$rootScope = $rootScope;
    this.eventService = eventService;
    this.capitalize = $filter('capitalize');
    this.entitlementsService = entitlementsService;
    this.pastEvents = false;
    this.userService = userService;
  }

  /**
   * Initializes data
   *
   */
  return _createClass(OrgEventEntitlements, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      this.userCanManageEntitlements = this.userService.matchesRoles({
        orgRole: 'entitlement_manager',
        orgId: this.organisation._id
      });
      this.getOrganizationEventsWithEntitlements().catch(function /* error */ () {
        return _this.eventEntitlementsPage = {
          error: EVENT_ENTITLEMENTS_ERROR
        };
      }).then(function () {
        return _this.entitlementsService.getAvailableProducts(_this.organisation._id);
      }).then(function (availableProducts) {
        return _this.availableProducts = availableProducts.reduce(function (accumulator, product) {
          accumulator[product.name] = _this.capitalize(product.name);
          return accumulator;
        }, {});
      }).catch(function /* error */ () {
        return _this.availableProductsError = AVAILABLE_PRODUCTS_ERROR;
      }).finally(function () {
        return _this.loading = false;
      });
    }

    /**
     * Fetches the event entitlements for the current organization and stores it in this.eventEntitlements
     *
     * @param {object} page - The object specifying the pagination
     */
  }, {
    key: "getOrganizationEventsWithEntitlements",
    value: function getOrganizationEventsWithEntitlements() {
      var _this2 = this;
      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        first: true
      };
      if (this.loading) {
        return;
      }
      this.loading = true;
      this.eventEntitlementsPage = null;
      return this.entitlementsService.getOrganizationEventsWithEntitlements(this.organisation._id, Object.assign(page, {
        limit: PAGE_LIMIT,
        pastEvents: this.pastEvents
      })).then(function (eventsDataPage) {
        eventsDataPage.items = _this2._formatEventData(eventsDataPage.items);
        _this2.eventEntitlementsPage = eventsDataPage;
        _this2.loading = false;
      });
    }

    /**
     * Opens the assign entitlement view for given product
     *
     */
  }, {
    key: "addEntitlement",
    value: function addEntitlement(eventId, product) {
      if (this.availableProductsError) {
        return this.$rootScope.setFlashMessage(AVAILABLE_PRODUCTS_ERROR, 'danger');
      }
      if (!this.canBeAdded(product)) {
        return;
      }
      this.$scope.$emit('CHANGE_TAB', {
        tab: 'assign-entitlement',
        params: {
          product: product.name,
          eid: eventId
        }
      });
    }

    /**
     * Formats events page data
     *
     * @returns {string} formated event data
     *
     * @param {object} eventsData - The object containing the initial event data
     */
  }, {
    key: "_formatEventData",
    value: function _formatEventData(eventsData) {
      var _this3 = this;
      return eventsData.map(function (eventData) {
        var eventNode = (eventData.eventNodeUrl || '').split('.')[0].replace('https://', '').replace('http://', '');
        var eventBackstageUrl = _this3.eventService.generateGeoOptimalEventUrl({
          node: eventNode,
          id: eventData.eventId || ''
        }, '', window.location.protocol);
        eventData.creationDate = moment(eventData.purchaseDateMs).format('YYYY/MM/DD');
        eventData.startDate = moment(eventData.eventStartDateMs).format('YYYY/MM/DD');
        eventData.endDate = moment(eventData.eventEndDateMs).format('YYYY/MM/DD');
        eventData.backstageUrl = eventBackstageUrl;
        return eventData;
      });
    }

    /**
     * Check if product can be added to event
     * @param {Object} product
     */
  }, {
    key: "canBeAdded",
    value: function canBeAdded(product) {
      return this.userCanManageEntitlements && this.availableProducts && !!this.availableProducts[product.name] && (product.multiple || !product.usage.available) && !product.usage.error;
    }

    /**
     * Shows the per event entitlements view
     *
     * @param {Event} $event
     * @param {String} eventId
     */
  }, {
    key: "openEventEntitlements",
    value: function openEventEntitlements($event, eventId) {
      $event.stopImmediatePropagation();
      this.$scope.$emit('CHANGE_TAB', {
        tab: 'per-event-entitlements',
        params: {
          eid: eventId
        }
      });
    }
  }, {
    key: "showPastEvents",
    value: function showPastEvents(past) {
      this.pastEvents = past;
      // refresh view
      this.getOrganizationEventsWithEntitlements();
    }
  }]);
}();
module.exports = angular.module('backstage.components.orgs.view-org.entitlements-manager.org-event-entitlements', ['backstage.services']).component('bsOrgEventEntitlements', {
  templateUrl: '/src/angular/components/orgs/view-org/org-entitlements-manager/org-event-entitlements/org-event-entitlements.html',
  bindings: {
    organisation: '<'
  },
  controllerAs: 'vm',
  controller: OrgEventEntitlements
}).name;